module.exports = __webpack_public_path__ + "img/step1.78a3dc48.png";